import React from 'react';
import PageHeader from '../components/PageHeader';

export default function AICrisisAdviser() {
  return (
    <div className="p-4">
      <PageHeader title="AI Crisis Adviser" />

      <div className="card shadow-sm">
        <div className="card-body p-0">
          <iframe
            src="https://www.chatbase.co/chatbot-iframe/hL7_KD9tAtnRlCR-U-ghz"
            width="100%"
            style={{ 
              height: '700px', 
              border: 'none',
              '--user-text-color': '#39325b'
            }}
            title="AI Crisis Adviser"
          />
        </div>
      </div>
    </div>
  );
} 